// © Microsoft Corporation. All rights reserved.

import { NavItem } from "./NavItem";
import { navItemTemplate as template } from "./NavItem.template";
import { navItemStyles as styles } from "./NavItem.styles";
import { customElement } from "@microsoft/fast-element";

@customElement({
    name: "msn-nav-item",
    template,
    styles,
    shadowOptions: {
        delegatesFocus: true
    }
})
export class MsnNavItem extends NavItem { }